// Correctif 19/10/2026 : un refus de validation de l'API renvoie « detail » sous forme
// de liste d'objets ; affiché tel quel dans un message, il faisait planter le module.
// On le convertit toujours en texte lisible.
export const normaliserDetail = (error) => {
  const data = error?.response?.data;
  if (data && data.detail !== undefined && typeof data.detail !== 'string') {
    const d = data.detail;
    data.detail = Array.isArray(d)
      ? d.map((e) => {
          const champ = Array.isArray(e?.loc) ? e.loc.filter((x) => x !== 'body' && x !== 'query').join('.') : '';
          return (champ ? champ + ' : ' : '') + (e?.msg || 'valeur invalide');
        }).join(' ; ') || 'Données invalides'
      : (d?.message || d?.msg || 'Données invalides');
  }
  return error;
};
